function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_363_3997)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.108 6.714l2.518-2.288c.594-.54.17-1.426-.636-1.426h-2.036a.91.91 0 00-.636.231l-4.54 4.124c-.339.347-.339.886 0 1.195l4.54 4.123a.91.91 0 00.636.232h2.036c.806 0 1.23-.887.636-1.426L11.505 9.55H16c4.527 0 8.203 3.713 8.203 8.296 0 4.587-3.68 8.318-8.203 8.318s-8.203-3.732-8.203-8.319c0-.783-.625-1.417-1.398-1.417-.773 0-1.399.634-1.399 1.418C5 23.998 9.931 29 16 29c6.065 0 11-4.997 11-11.131 0-6.154-4.931-11.155-11-11.155h-4.892z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_363_3997"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h32v32H0z"
})))));